(function(){
  var S = window.AF_MARK || {};

  /* One id per section instance. Every run removes the previous mount before
     building a new one, so re-rendering in the theme editor replaces the mark
     instead of stacking another copy of it next to the last. */
  var UID = "af-mark-live-" + (S.sid || "af");

  var CAMO = {
    m81:      ["#1D1E1C","#4E3A2A","#5F6B4E","#A69C7E"],
    woodland: ["#191A16","#2F3C26","#57452F","#5E6B42","#87744B","#AFA477"],
    tiger:    ["#15150E","#2C3120","#474D2F","#6E7446","#948D5B","#C6B884"],
    desert:   ["#2A2118","#4E3E28","#755D39","#9C8052","#BFA26E","#E3CC9A"],
    night:    ["#0D1014","#1F262E","#38434F","#55626F","#7B8895","#ABB6C2"],
    bone:     ["#26241E","#443F35","#66604F","#8B8270","#B3A991","#E1D8C1"],
    cherry:   ["#1A0709","#3E0B10","#6E0C14","#9C1119","#C4262E","#E8938C"]
  };
  /* Croc: 0 and 1 are the two scale tones, 2 is the lit seam between scales,
     3 is the flat ink used by the non-cutout logo styles. */
  var CROC = {
    black:  ["#0C0C0D","#17171A","#F1EFE8","#8E8C82"],
    cherry: ["#6B0A10","#8C1017","#F0A49B","#B8262E"],
    navy:   ["#0E1626","#182137","#B4C4DF","#5673A4"],
    moss:   ["#1A2012","#242C19","#CCD5AB","#6E7E4A"],
    cognac: ["#22150C","#2E1D11","#E6C8A2","#96643A"],
    bone:   ["#D2CAB7","#C3BAA4","#332F27","#7E7565"]
  };
  var PLAID = {
    babyblue: ["#FFFFFF","#AFD6ED","#5F9FCB","#2E6E99"],
    sky:      ["#FBFDFF","#C8E4F5","#7FBCE0","#3E87B4"],
    black:    ["#FFFFFF","#B9BAB8","#35373A","#0C0D0F"],
    red:      ["#F6EFE8","#C4685C","#7A1F1C","#1B1412"],
    cherry:   ["#FBEDEC","#E0787C","#B00E1B","#3A0A0E"],
    moss:     ["#F4F2E6","#B6C08E","#5E6B3C","#2C3420"],
    tan:      ["#FBF6EC","#DCC79E","#A8875A","#5C452C"]
  };
  var FLAG = {
    usa:   ["#FFFFFF","#B22234","#3C3B6E"],
    jam:   ["#009B3A","#1A1A1A","#FED100"],
    uk:    ["#FFFFFF","#C8102E","#012169"],
    chile: ["#FFFFFF","#D52B1E","#0039A6"]
  };

  function palette(){
    if(S.texture === "croc")  return CROC[S.crocWay]   || CROC.black;
    if(S.texture === "plaid") return PLAID[S.plaidWay] || PLAID.babyblue;
    if(S.texture === "flag")  return FLAG[S.flagWay]   || FLAG.usa;
    return CAMO[S.camoWay] || CAMO.m81;
  }
  function lightest(pal){
    var best = pal[0], bl = -1;
    for(var i=0;i<pal.length;i++){
      var n = parseInt(pal[i].slice(1),16);
      var l = 0.2126*((n>>16)&255) + 0.7152*((n>>8)&255) + 0.0722*(n&255);
      if(l > bl){ bl = l; best = pal[i]; }
    }
    return best;
  }

  /* 32-bit integer hashing throughout — anything that multiplies past 2^53
     loses precision and the "noise" starts correlating down columns. */
  function hash(x, y, seed){
    var h = Math.imul(x,374761393) ^ Math.imul(y,668265263) ^ Math.imul(seed,1442695041);
    h = Math.imul(h ^ (h>>>13), 1274126177);
    return ((h ^ (h>>>16)) >>> 0) / 4294967296;
  }
  function noise(x, y, seed){
    var ix=Math.floor(x), iy=Math.floor(y), fx=x-ix, fy=y-iy;
    var sx=fx*fx*(3-2*fx), sy=fy*fy*(3-2*fy);
    var a=hash(ix,iy,seed), b=hash(ix+1,iy,seed);
    var c=hash(ix,iy+1,seed), d=hash(ix+1,iy+1,seed);
    return a + (b-a)*sx + (c-a)*sy + (a-b-c+d)*sx*sy;
  }
  function camoNoise(x, y){
    var p = Math.max(2, S.patch || 9);
    var v = noise(x/p, y/(p*0.8), 17)*0.62
          + noise(x/(p*0.45), y/(p*0.36), 91)*0.26
          + noise(x/(p*0.19), y/(p*0.15), 233)*0.12;
    return Math.max(0, Math.min(0.999, (v - 0.30)/0.40));
  }
  function inStar(px, py, cx, cy, R){
    var dx=px-cx, dy=py-cy, d=Math.sqrt(dx*dx+dy*dy);
    var seg=Math.PI*2/5, half=seg/2;
    var a=Math.atan2(dy,dx)+Math.PI*1.5;
    var u=((a%seg)+seg)%seg, phi=u>half?seg-u:u;
    var r=R*0.38, sh=Math.sin(half);
    return d < (R*r*sh)/(R*Math.sin(phi)+r*Math.sin(half-phi));
  }
  /* Flags are drawn from their real geometry, so they stay sharp at any cell
     size and cost nothing to load. 0 = light, 1 = red, 2 = blue/dark. */
  function flagTone(u, v, id){
    if(id === "usa"){
      if(u < 0.40 && v < 7/13){
        var su=u/0.40*11-0.5, sv=v/(7/13)*9-0.5;
        var rx=Math.round(su), ry=Math.round(sv);
        if(((rx+ry)%2)===0){
          var ax=(su-rx)/0.5, ay=(sv-ry)/0.5;
          if(ax*ax+ay*ay < 0.34) return 0;
        }
        return 2;
      }
      return (Math.floor(v*13)%2===0) ? 1 : 0;
    }
    if(id === "jam"){
      if(Math.min(Math.abs(v-u), Math.abs(v-(1-u))) < 0.105) return 2;
      return (Math.abs(v-0.5) > Math.abs(u-0.5)) ? 0 : 1;
    }
    if(id === "uk"){
      var du=u-0.5, dv=v-0.5;
      if(Math.abs(du)<0.105 || Math.abs(dv)<0.105)
        return (Math.abs(du)<0.055 || Math.abs(dv)<0.055) ? 1 : 0;
      var d1=v-u, d2=v-(1-u), near1=Math.abs(d1)<Math.abs(d2);
      if((near1?Math.abs(d1):Math.abs(d2)) < 0.135){
        var side = near1 ? (u<0.5?1:-1) : (u<0.5?-1:1);
        var s2 = (near1?d1:d2)*side;
        return (s2 > 0.022 && s2 < 0.098) ? 1 : 0;
      }
      return 2;
    }
    if(v >= 0.5) return 1;
    if(u < 1/3) return inStar(u, v, 1/6, 0.25, 0.115) ? 0 : 2;
    return 0;
  }

  // ---- page anchors ------------------------------------------------------
  function findLogoEl(){
    var sel = [".store-name img", ".header-center img", ".password-header img"];
    for(var i=0;i<sel.length;i++){
      var n = document.querySelector(sel[i]);
      if(n) return n;
    }
    return null;
  }
  function column(){
    return document.querySelector(".password-text-section") ||
           document.querySelector(".password-page") ||
           document.body;
  }
  /* The SMS capture is a Klaviyo embed. Climb from it to whichever ancestor is
     a direct child of the content column, so the mark lands as a sibling above
     the whole form block rather than inside it. */
  function signupBlock(){
    var f = document.querySelector('[class*="klaviyo-form-"]') ||
            document.querySelector('.password-klaviyo, .klaviyo-button');
    if(!f) return null;
    var host = column(), n = f;
    while(n.parentNode && n.parentNode !== host && n.parentNode !== document.body) n = n.parentNode;
    return n.parentNode ? n : null;
  }

  function killOld(){
    var old = document.getElementById(UID);
    if(old && old.parentNode) old.parentNode.removeChild(old);
  }

  function place(wrap){
    var pos = S.position || "signup";
    if(pos === "header"){
      var lg = findLogoEl();
      if(lg && lg.parentNode){ lg.parentNode.insertBefore(wrap, lg.nextSibling); return; }
    }
    if(pos === "signup"){
      var blk = signupBlock();
      if(blk){ blk.parentNode.insertBefore(wrap, blk); return; }
    }
    var host = column();
    host.insertBefore(wrap, host.firstChild);
  }

  function boot(){
    killOld();
    var el = findLogoEl();
    var url = S.logoSrc || (el ? (el.currentSrc || el.src) : "");
    if(!url) return;
    /* Fetched as a CORS request so the pixels can be read back. If that is
       refused we fall back to the element already on the page. */
    var img = new Image();
    img.crossOrigin = "anonymous";
    img.onload  = function(){ try { run(img); } catch(e){} };
    img.onerror = function(){
      var e2 = findLogoEl();
      if(e2 && e2.naturalWidth){ try { run(e2); } catch(e){} }
    };
    img.src = url;
  }

  function run(src){
    if(!src.naturalWidth) return;
    killOld();

    var pal = palette(), P = pal.length;
    var COLS = Math.max(40, Math.round(S.cols || 150));
    var scratch = S.behavior === "scratch";
    var ROWS = Math.max(4, Math.round(COLS * (src.naturalHeight/src.naturalWidth)));
    if(scratch) ROWS = Math.max(ROWS, Math.round(COLS*0.52));
    var N = COLS*ROWS, i, x, y;

    /* In scratch mode the cover is a solid patch of texture and the mark lives
       underneath it, so the logo mask is ignored for the fill. */
    var LS = scratch ? "cover" : (S.lstyle || "cutout");
    var CUT = S.cut || 0.45;

    /* Read the artwork onto the cell grid. Transparency marks the logo; if the
       file has none we paint a white ground and fall back to brightness, so a
       flattened logo still works instead of filling the whole rectangle. */
    var k = document.createElement("canvas");
    k.width = COLS; k.height = ROWS;
    var kx = k.getContext("2d", {willReadFrequently:true});
    var fit = Math.min(COLS*0.88/src.naturalWidth, ROWS*0.88/src.naturalHeight);
    var dw = src.naturalWidth*fit, dh = src.naturalHeight*fit;
    var ox = (COLS-dw)/2, oy = (ROWS-dh)/2;

    kx.clearRect(0,0,COLS,ROWS);
    kx.drawImage(src, ox, oy, dw, dh);
    var d;
    try { d = kx.getImageData(0,0,COLS,ROWS).data; } catch(e){ return; }

    var drawn = 0, clear = 0;
    for(i=0;i<N;i++){ if(d[i*4+3] > 20) drawn++; if(d[i*4+3] < 200) clear++; }
    var useAlpha = clear > drawn*0.15;
    if(!useAlpha){
      kx.fillStyle = "#fff"; kx.fillRect(0,0,COLS,ROWS);
      kx.drawImage(src, ox, oy, dw, dh);
      try { d = kx.getImageData(0,0,COLS,ROWS).data; } catch(e2){ return; }
    }

    var v = new Float32Array(N);
    for(i=0;i<N;i++){
      var a = d[i*4+3]/255;
      if(useAlpha) v[i] = S.invert ? (1-a) : a;
      else {
        var lum = (0.2126*d[i*4] + 0.7152*d[i*4+1] + 0.0722*d[i*4+2])/255;
        v[i] = a * (S.invert ? lum : (1-lum));
      }
    }

    // ---- tone grid -------------------------------------------------------
    var tone = new Int8Array(N), dx = new Float32Array(N), dy = new Float32Array(N);
    var done = new Uint8Array(N);

    var CHK  = Math.max(2, Math.round(S.check||8)), duty = S.duty||0.5;
    var lw   = Math.max(1, Math.round(CHK*0.16)), big = CHK*Math.max(2, S.over||0);
    var rep  = Math.max(1, Math.round(S.repeat||1));
    var SC   = Math.max(2, S.scale||6), SEAM = S.seam||0.30, WARP = (S.warp==null?0.5:S.warp);
    var con  = (S.contrast==null?1:S.contrast);
    var split = Math.floor(P/2), span = P - split*con, lift = Math.round(split*con);

    function crocCentre(ii, jj){
      var jx = (hash(ii,jj,555) - 0.5) * WARP * 0.9;
      var jy = (hash(ii,jj,777) - 0.5) * WARP * 0.9;
      var sv = 1 + (hash(ii,jj,999) - 0.5) * WARP * 0.5;
      return [(ii+0.5+jx)*SC, (jj+0.5+jy)*SC, sv];
    }
    function clampT(t){ return Math.max(0, Math.min(P-1, t)); }

    for(y=0;y<ROWS;y++) for(x=0;x<COLS;x++){
      i = y*COLS+x;
      var ink = v[i] >= CUT;

      if(S.texture === "croc"){
        var gx = Math.floor(x/SC), gy = Math.floor(y/SC), d1=1e9, d2=1e9, ii, jj;
        for(jj=gy-1;jj<=gy+1;jj++) for(ii=gx-1;ii<=gx+1;ii++){
          var p = crocCentre(ii,jj);
          var ddx = x-p[0], ddy = y-p[1];
          var dd = Math.sqrt(ddx*ddx+ddy*ddy)/p[2];
          if(dd<d1){ d2=d1; d1=dd; } else if(dd<d2){ d2=dd; }
        }
        var onSeam = (d2-d1) < SEAM*SC;
        var body = hash(x,y,31) > 0.5 ? 1 : 0;
        if(LS === "cover")       tone[i] = onSeam ? 2 : body;
        else if(LS === "cutout") tone[i] = !ink ? -1 : (onSeam ? 2 : body);
        else if(ink && LS === "knock") tone[i] = -1;
        else if(onSeam)          tone[i] = 2;
        else if(ink)             tone[i] = (LS === "solid") ? 2 : 3;
        else                     tone[i] = body;
        continue;
      }

      if(S.texture === "plaid"){
        var t = ((x % CHK)/CHK < duty ? 1:0) + ((y % CHK)/CHK < duty ? 1:0);
        if(S.over > 1 && ((x % big) < lw || (y % big) < lw)) t = P-1;
        if(LS === "cutout" && !ink){ tone[i] = -1; continue; }
        if(LS === "knock"  &&  ink){ tone[i] = -1; continue; }
        if(LS === "solid"  &&  ink){ tone[i] = P-1; continue; }
        if(LS === "tone")  t = ink ? Math.min(P-1, t+1) : Math.max(0, t-1);
        tone[i] = clampT(t);
        continue;
      }

      if(S.texture === "flag"){
        var ft = flagTone((x/COLS*rep)%1, (y/ROWS*rep)%1, S.flagWay);
        if(LS === "cutout" && !ink){ tone[i] = -1; continue; }
        if(LS === "knock"  &&  ink){ tone[i] = -1; continue; }
        if(LS === "solid"  &&  ink){ tone[i] = P-1; continue; }
        tone[i] = clampT(ft);
        continue;
      }

      var nv = camoNoise(x,y);
      if(LS === "cover"){ tone[i] = clampT(Math.floor(nv*P)); continue; }
      if(LS === "cutout"){ tone[i] = ink ? clampT(Math.floor(nv*P)) : -1; continue; }
      if(ink && LS === "knock"){ tone[i] = -1; continue; }
      if(ink && LS === "solid"){ tone[i] = P-1; continue; }
      tone[i] = clampT((ink ? lift : 0) + Math.floor(nv*span));
    }

    /* Cells near the border are dropped at random, thinning toward the edge,
       so the patch frays into the page instead of ending on a straight line.
       There is no border to fray in cutout — the mark is the silhouette. */
    if(S.feather > 0 && LS !== "cutout"){
      for(y=0;y<ROWS;y++) for(x=0;x<COLS;x++){
        var ex = Math.min(x, COLS-1-x)/(COLS*0.5);
        var ey = Math.min(y, ROWS-1-y)/(ROWS*0.5);
        var e = Math.min(ex, ey);
        if(e < S.feather){
          var q = e/S.feather;
          if(hash(x,y,4711) > q*q) tone[y*COLS+x] = -1;
        }
      }
    }

    // ---- one wrapper, built from scratch, centred by its own flex row -----
    var align = S.align === "left" ? "flex-start" : S.align === "right" ? "flex-end" : "center";
    var wrap = document.createElement("div");
    wrap.id = UID;
    wrap.style.cssText = "display:flex;width:100%;box-sizing:border-box;" +
                         "justify-content:" + align + ";align-items:center;flex-direction:column;" +
                         "margin:" + (S.spaceTop||0) + "px 0 " + (S.spaceBot||0) + "px;";

    var base = S.maxW || 520;
    if(S.position === "header"){
      var lgEl = findLogoEl();
      if(lgEl && lgEl.offsetWidth) base = lgEl.offsetWidth;
    }
    var boxW = Math.max(80, Math.round(base * (S.markW == null ? 1 : S.markW)));

    var box = document.createElement("div");
    box.style.cssText = "position:relative;touch-action:none;max-width:100%;width:" + boxW + "px";
    wrap.appendChild(box);

    var under = null, lineEls = [];
    if(scratch){
      under = document.createElement("div");
      under.style.cssText = "position:absolute;inset:0;display:flex;flex-direction:column;" +
                            "align-items:center;justify-content:center;gap:.4em;pointer-events:none";
      box.appendChild(under);

      /* Our own copy of the artwork, so the theme's logo element is never
         moved out of the header — moving it is what broke the centring. */
      var mk = document.createElement("img");
      mk.src = src.src || src.currentSrc;
      mk.alt = "";
      mk.style.cssText = "display:block;width:"+Math.round(boxW*0.62)+"px;max-width:70%;height:auto";
      under.appendChild(mk);

      [S.line1, S.line2].forEach(function(txt){
        if(!txt) return;
        var ln = document.createElement("div");
        ln.textContent = String(txt).toUpperCase();
        var fam = (S.msgFont && S.msgFont !== "inherit")
                ? ("'" + S.msgFont + "', Impact, sans-serif") : "inherit";
        var wgt = (S.msgFont === "Anton" || S.msgFont === "Bebas Neue") ? 400 : 700;
        ln.style.cssText = "font-family:"+fam+";font-weight:"+wgt+";line-height:1.05;" +
                           "letter-spacing:"+(S.track||0)+"em;text-indent:"+(S.track||0)+"em;" +
                           "white-space:nowrap;color:"+(S.msgColor || lightest(pal));
        under.appendChild(ln);
        lineEls.push(ln);
      });
    }

    var cv = document.createElement("canvas");
    cv.style.cssText = "display:block;width:100%;position:relative;z-index:1";
    box.appendChild(cv);

    var hint = null;
    if(scratch && S.hint){
      hint = document.createElement("div");
      hint.textContent = S.hint;
      hint.style.cssText = "text-align:center;font-size:11px;letter-spacing:.18em;opacity:.45;" +
                           "margin-top:8px;transition:opacity .4s";
      wrap.appendChild(hint);
    }

    /* The sign-up form is built into the wrapper itself, so it is always
       directly under the mark no matter where the wrapper gets mounted. */
    if(S.sms){
      var sms = document.createElement("div");
      sms.style.cssText = "width:" + boxW + "px;max-width:100%;margin-top:" +
                          (S.smsGap == null ? 16 : S.smsGap) + "px";
      sms.innerHTML = S.sms;
      wrap.appendChild(sms);
    }

    /* Hiding the theme's logo lives in a <style> inside the wrapper, so the
       rule disappears the moment the wrapper does and the logo comes back. */
    if(S.hideLogo){
      var st = document.createElement("style");
      st.textContent = ".store-name img,.header-center img,.password-header img{display:none!important}";
      wrap.appendChild(st);
    }

    place(wrap);

    // ---- paint -----------------------------------------------------------
    var c = cv.getContext("2d"), cell = 4, DPR = 1;
    function layout(){
      var w = box.clientWidth || boxW;
      cell = w/COLS;
      var h = cell*ROWS;
      DPR = Math.min(2, window.devicePixelRatio || 1);
      cv.style.height = h + "px";
      cv.width = Math.round(w*DPR); cv.height = Math.round(h*DPR);
      if(lineEls.length){
        var size = Math.max(11, h*(S.msgSize||0.30)), q;
        function setSize(){
          for(q=0;q<lineEls.length;q++)
            lineEls[q].style.fontSize = (size*(q?0.62:1)).toFixed(1)+"px";
        }
        /* Measure the lines themselves. The wrapper is absolutely positioned
           at the full width of the patch, so its scrollWidth always trips the
           test and the type shrinks to the floor every time. */
        function widest(){
          var m = 0, z;
          for(z=0;z<lineEls.length;z++) m = Math.max(m, lineEls[z].scrollWidth);
          return m;
        }
        setSize();
        var guard = 0;
        while(widest() > w*0.92 && size > 11 && guard++ < 80){ size *= 0.95; setSize(); }
      }
      draw();
    }
    function draw(){
      c.setTransform(DPR,0,0,DPR,0,0);
      c.clearRect(0,0,cv.width,cv.height);
      var s = cell + 0.7;   // half-pixel overlap, otherwise hairline seams show
      for(var y=0;y<ROWS;y++) for(var x=0;x<COLS;x++){
        var i = y*COLS+x, t = tone[i];
        if(t < 0 || done[i]) continue;
        c.fillStyle = pal[t];
        c.fillRect(x*cell+dx[i], y*cell+dy[i], s, s);
      }
    }

    // ---- cursor ----------------------------------------------------------
    var PTS = Math.max(3, S.points||5), INN = S.inner||0.38;
    var ROT = (S.rotDeg||0)*Math.PI/180, RAD = S.radius||120, STR = S.strength||30;
    var HARD = (S.hard==null?0.60:S.hard), EASE = (S.ease==null?0.14:S.ease);
    var starred = S.shape !== "circle";
    var reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    function reach(ax, ay){
      if(!starred) return RAD;
      var seg = (Math.PI*2)/PTS, half = seg/2;
      var a = Math.atan2(ay, ax) + ROT;
      var u = ((a % seg) + seg) % seg;
      var phi = u > half ? seg - u : u;
      var r = RAD*INN, sh = Math.sin(half);
      return (RAD*r*sh)/(RAD*Math.sin(phi) + r*Math.sin(half - phi));
    }

    var total = 0, cleared = 0, faded = false;
    for(i=0;i<N;i++) if(tone[i] >= 0) total++;

    var px=-9e9, py=-9e9, on=false, raf=null;
    function tick(){
      var moving = false, half = cell/2;
      for(var y=0;y<ROWS;y++) for(var x=0;x<COLS;x++){
        var i = y*COLS+x;
        if(tone[i] < 0 || done[i]) continue;
        var ax = x*cell+half-px, ay = y*cell+half-py;
        if(scratch){
          if(on && Math.sqrt(ax*ax+ay*ay) < reach(ax,ay)){ done[i]=1; cleared++; moving=true; }
          continue;
        }
        var tx=0, ty=0;
        if(on){
          var dd = Math.sqrt(ax*ax+ay*ay), R = reach(ax,ay);
          if(dd < R && dd > 0.001){
            var f = Math.pow(1-dd/R, HARD);
            tx = (ax/dd)*f*STR; ty = (ay/dd)*f*STR;
          }
        }
        dx[i] += (tx-dx[i])*EASE; dy[i] += (ty-dy[i])*EASE;
        if(Math.abs(dx[i])>0.03 || Math.abs(dy[i])>0.03) moving = true;
      }
      draw();
      if(hint && !faded && total && cleared/total > 0.04){ faded = true; hint.style.opacity = "0"; }
      raf = (on||moving) ? requestAnimationFrame(tick) : null;
    }
    function start(){ if(!raf && !reduced) raf = requestAnimationFrame(tick); }
    function move(mx, my){
      var r = cv.getBoundingClientRect();
      px = mx-r.left; py = my-r.top; on = true; start();
    }
    box.addEventListener("mousemove", function(e){ move(e.clientX, e.clientY); });
    box.addEventListener("mouseleave", function(){ on=false; start(); });
    box.addEventListener("touchmove", function(e){
      if(e.touches[0]) move(e.touches[0].clientX, e.touches[0].clientY);
    }, {passive:true});
    box.addEventListener("touchend", function(){ on=false; start(); });
    window.addEventListener("resize", layout);

    layout();
    if(scratch && reduced){
      for(i=0;i<N;i++) done[i]=1;
      draw();
      if(hint) hint.style.display = "none";
    }
  }

  // theme editor lifecycle — never leave a stale mark behind
  document.addEventListener("shopify:section:unload", function(e){
    if(e.detail && ("af-mark-live-" + e.detail.sectionId) === UID) killOld();
  });

  if(document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
